import config from '../config';
import { fetchMe } from '../api';

const STORAGE_KEY = 'rebelity_payroll_session';

export function readSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed) return null;
    if (parsed.source === 'cookie' && parsed.username) return parsed;
    if (!parsed.token) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeSession(session) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearSession() {
  localStorage.removeItem(STORAGE_KEY);
}

export function isAuthenticated() {
  const session = readSession();
  return !!(session && (session.source === 'cookie' || session.token));
}

export function getToken() {
  const session = readSession();
  if (!session || session.source === 'cookie') return null;
  return session.token || null;
}

export async function restoreSessionFromCookie() {
  try {
    const { res, data } = await fetchMe();
    if (!res.ok || data?.status !== 'Ok' || !data?.user?.username) {
      if (readSession()?.source === 'cookie') clearSession();
      return null;
    }
    const session = {
      source: 'cookie',
      username: data.user.username,
      tenant: data.tenant || null,
    };
    writeSession(session);
    return session;
  } catch {
    if (readSession()?.source === 'cookie') clearSession();
    return null;
  }
}

export function buildBistroLoginUrl(returnPath = '/app') {
  const returnUrl = `${config.payrollOrigin}${returnPath}`;
  return `${config.bistroAdminUrl}/#/login?returnUrl=${encodeURIComponent(returnUrl)}`;
}